/**
 * 模块：系统事件报警
 * 作者：haikuo.zhang
 * 时间：2021-09-14
 */

export const colsChecked = 'systemEvent/colsChecked';
export const DescribeInstanceSystemEvents = 'systemEvent/DescribeInstanceSystemEvents';
export const ModifyInstanceMaintenanceAttribute = 'systemEvent/ModifyInstanceMaintenanceAttribute';
